import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { FluidLeftLayout } from '../../../layouts';
import ResolvedReason from '../ResolvedReason';
import CustomRiskScoreDetails from '../Vulnerability/CustomRiskScoreDetails';
import Dependency from '../Vulnerability/Dependency';
import Description from '../Vulnerability/Description';
import Details from '../Vulnerability/Details';
import MalwareDescription from '../Vulnerability/MalwareDescription';
import NVDBaseMetrics from '../Vulnerability/NVDBaseMetrics';
import References from '../Vulnerability/References';
import Remediation from '../Vulnerability/Remediation';

/**
 * A component that renders the detailed content of a vulnerability issue in a full-page layout.
 * Handles both traditional vulnerability issues and malware issues.
 */
const VulnerabilityIssueDetailContent: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails);
  const isMalware = issueDetails?.type === 'malware';

  if (isMalware) {
    return (
      <FluidLeftLayout>
        <FluidLeftLayout.Left>
          <ResolvedReason />
          <MalwareDescription malwareRevisionId={issueDetails.malwareRevisionId} />
          <Dependency />
        </FluidLeftLayout.Left>
        <FluidLeftLayout.Right />
      </FluidLeftLayout>
    );
  }

  return (
    <FluidLeftLayout>
      <FluidLeftLayout.Left>
        <ResolvedReason />
        <CustomRiskScoreDetails />
        <Remediation />
        <Details />
        <Dependency />
      </FluidLeftLayout.Left>
      <FluidLeftLayout.Right>
        <Description />
        <NVDBaseMetrics />
        <References />
      </FluidLeftLayout.Right>
    </FluidLeftLayout>
  );
};

export default VulnerabilityIssueDetailContent;
